import { useEmployeeFormContext } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormProvider/useEmployeeFormContext';

type UseSftpWarningMessage = {
  sftpEnabled: boolean;
};

export function useSftpWarningMessage(): UseSftpWarningMessage {
  const { corpData } = useEmployeeFormContext();
  const { sftpEmployeesEnabled, sftpExpenseCodesEnabled } = corpData;

  return {
    sftpEnabled: sftpEmployeesEnabled || sftpExpenseCodesEnabled,
  };
}
